import { Box, Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';

export const ExpiredPlan = ({ isOnFreeTrial }: { isOnFreeTrial: boolean }) => {
  const { t } = useScopedTranslation();
  return (
    <Box
      alignSelf="center"
      backgroundColor="surface.brand.secondary-2.default"
      borderRadius="radius.xl"
      flex={1}
      overflow="hidden"
      padding="spacing.general.x4"
      width="100%"
    >
      <Column gap="spacing.general.x3">
        <Text fontSize={20} fontWeight="700">
          {t(`planExpired.title.${isOnFreeTrial ? 'trial' : 'regular'}`)}
        </Text>
        <Text fontSize={16}>{t(`planExpired.text.${isOnFreeTrial ? 'trial' : 'regular'}`)}</Text>
      </Column>
    </Box>
  );
};
